/*!
=========================================================
* 受注一覧
=========================================================
*/
import React from "react";

import {
  Button,
  Table, Col,
} from "reactstrap";

import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import DialogBase from '../Base/DialogBase';
import InputText from '../FormParts/InputText';
import InputSelect from '../FormParts/InputSelect';
import InputNumber from '../FormParts/InputNumber';
import InputCheckBox from '../FormParts/InputCheckBox';
import Format from '../../common/Format';
//import ListBase from '../Base/ListBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.15
import Definition from '../../common/Definition';
import CustomTd from '../ViewParts/CustomTd';
import OptionConvert from '../../common/OptionConvert';
import WithRole from '../FormParts/ButtonWithRole';
import InputFile from '../FormParts/InputFile';
import { GetMessage, getErrorCodes } from "../../variables/message";
import GoogleDrive from "../../common/GoogleDrive";
import { 
  cst_payment_request_status_search,
  ORDER_BOX_STATUS
} from '../../variables/codes_map';
const moment = require("moment");

var domain = "";

class List extends ListBase {
  default_column = [
    { Header: '見積ID',accessor: 'ESTIMATE__estimate_natural_id',headerClassName:'text-center',className:'text-left text-top',width:160,minWidth:50,defaultView:true},
    { Header: '顧客情報',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50},
    { Header: '顧客情報（下請）',accessor: '___JOIN_subcontract_customer_information',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50},
    { Header: '現場名/工事番号',accessor: '___JOIN_project_information',headerClassName:'text-center',className:'text-left text-top',width:120,minWidth:50},
    { Header: '現場住所',accessor: '___JOIN_project_addr',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '仕入先情報',accessor: '___JOIN_quote_use_parking',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    { Header: '仕入値',accessor: '___JOIN_quote_cost_amt',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50},
    { Header: '契約期間',accessor: '___JOIN_quote_available_date',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    { Header: '仕入先担当者',accessor: 'ESTIMATE__payment_user_id',headerClassName:'text-center',className:'text-left text-top',width:140,minWidth:50, defaultView:true},
    { Header: '仕入先からの請求書',accessor: 'actions_3',headerClassName:'text-center',className:'text-center',width:135,minWidth:50, sortable : false},
    { Header: '仕入値調整',accessor: 'actions_1',headerClassName:'text-center',className:'text-center',width:111.1111111111111,minWidth:50, sortable : false},
    { Header: '仕入依頼',accessor: 'actions_2',headerClassName:'text-center',className:'text-center',width:135,minWidth:50, sortable : false},
    { Header: '失注',accessor: 'actions_4',headerClassName:'text-center',className:'text-center',width:135,minWidth:50, sortable : false},
    { Header: '支払期日',accessor: 'PAYMENT__payment_limit_date',headerClassName:'text-center',className:'text-left text-top',width:130,minWidth:50,defaultView:true},
    { Header: '受注管理メモ',accessor: 'ESTIMATE__order_memo',headerClassName:'text-center',className:'text-left text-top',width:500,minWidth:50,defaultView:true},
    { Header: '差戻メモ',accessor: 'ESTIMATE__payment_return_memo',headerClassName:'text-center',className:'text-left text-top',width:500,minWidth:50,defaultView:true},
    { Header: '最終更新情報', accessor: '___JOIN_estimate_update', headerClassName: "text-center", className: "text-left text-top" ,width:225,defaultView:true},
  ];

  constructor(props) {
    super(props);

    // 遷移元（仕入依頼（駐車場）、支払訂正）で検索要求を変える
    const is_from_parking = props.location.pathname=="/requestpayment/parking"
    
    Object.assign(this.state, {
      title: '支払訂正',
      add_url: '',
//      search_url: '/api/requestpayment/parking',
      search_url: '/api/requestpayment/parking/unlimit',
      column: this.default_column,
      detail_search:false,
      valid: true,
      payment:[],
      dialogData:{},
      ulid: "",
      error_modal: false,
      message:"",
      searchData:{
        values:{
          payment_request_status: is_from_parking ? ["0","2"] :  ["2"],
          minimum_order_box_status: is_from_parking ? undefined : ORDER_BOX_STATUS.DELIVERYSLIP
        },
        errors:{},
        requiredData:{}
      },
      landmark_user:[],
      auto_scroll:true,
      is_from_parking: is_from_parking
    });
    this.dialogchangeamt = React.createRef();
    this.dialog = React.createRef();
    this.dialognnotpayment = React.createRef();
    this.dialogConfirm = React.createRef();
    this.dialogUpload = React.createRef();
    this.dialogLostBid = React.createRef();

    this.dataMap = this.dataMap.bind(this)
    this.callbackErrorModal = this.callbackErrorModal.bind(this);
    this.validateCallback = this.validateCallback.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      // console.log(res.Data);
      const user_list = OptionConvert.optionsById(res.Data)
      this.setState({
        landmark_user:user_list}
      , () => {
        this.search(false);
      });
    })
    document.body.style.overflow = "auto";
  }

  getLastUpdaedUser(lastupdate_user_id){
    const user_list = this.state.landmark_user;
    const matchedUser = user_list.find((singleUser)=>singleUser.id===lastupdate_user_id)
    const lastupdate_user = matchedUser ? (
      {
        name:matchedUser.label,
        picture:matchedUser.picture,
        ulid:matchedUser.id,
        id:matchedUser.value
      }
    ):(
      {
        name:"",
        picture:"",
        ulid:"",
        id:""
      }
    )
    return lastupdate_user
  }

  dataMap(data) {
    return data.map((prop, key) => {
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons, prop)
      const lastupdate_user = this.getLastUpdaedUser(prop.lastupdate_user_id)
      const prop_tmp = {user_name:lastupdate_user.name, update_timestamp:prop.update_timestamp}
      const lost_check = data.filter((d)=>(d.payment_status == 4 && d.estimate_natural_id == prop.estimate_natural_id || d.payment_status == 6 && d.estimate_natural_id == prop.estimate_natural_id)).length > 0
      return {
        id: key,
        prop,
        ESTIMATE__estimate_natural_id: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_payment_request_id', prop)}} />,
        ___JOIN_client_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />,
        ___JOIN_subcontract_customer_information : <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information', prop)}} />,
        ___JOIN_project_information: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_information', prop)}} />,
        ___JOIN_project_addr: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_addr', prop)}} />,
        ___JOIN_quote_available_date: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_available_date', prop)}} />,
        ___JOIN_quote_use_parking: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_use_parking', prop)}} />,
        ___JOIN_quote_cost_amt: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_cost_amt', prop)}} /> ,
        actions_3: <>
        <ButtonWithTooltipWithRole
          onclick={() => { 
            this.setState({
              dialogData:prop
            }, ()=>{
              this.dialogUpload.current.show()
            })
          } }
          size="sm"
          id="tmp"
          label={prop.latest_pdf_supplier_invoice_url&&"請求書"}
          message="仕入先からの請求書"
        />
        {
          prop.latest_pdf_supplier_invoice_url && <>
          <br/>
            <a href={`/api/gcs_download/${prop.latest_pdf_supplier_invoice_url}?d=請求書_${moment().format("YYYYMMDDHHmmss")}`} target="_blank">
              請求書確認
            </a>
          </>
        }
        </>,
        actions_1: (<ButtonWithRole button_id="BTN_E1_01_02170" size="sm" onClick={() => { this.dialogchangeamt.current.show(); this.setState({dialogData: prop}) }} className="text-center">調整</ButtonWithRole>),
        actions_2: (<ButtonWithRole 
          button_id="BTN_E1_01_02190" 
          size="sm" 
          onClick={() => { this.props.history.push(
            {
              pathname:(this.state.is_from_parking ? "parking/add/" : "requestpayment/parking/add/") + prop.estimate_natural_id,
              transition_source:this.props.location.pathname
            }) }
          } 
          className="text-center"
          disabled={prop.payment_request_status == "1"}
        >仕入依頼</ButtonWithRole>),
        actions_4: (<ButtonWithRole 
          button_id="BTN_E1_01_02191" 
          size="sm" 
          onClick={() => { this.setState({dialogData: prop}, ()=>this.dialogLostBid.current.show()) }
          } 
          className="text-center"
          disabled={lost_check} // 失注もしくは仕入済は失注ボタンdisable
        >失注</ButtonWithRole>),
        PAYMENT__payment_limit_date: Format.format_date(prop.payment_limit_date),
        ESTIMATE__order_memo: prop.order_memo,
        ESTIMATE__payment_return_memo: prop.payment_return_memo,
        ___JOIN_estimate_update: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_estimate_update', prop_tmp)}} />,
        // 2022/07/11 
        ESTIMATE__payment_user_id: prop.payment_user_id!=null? this.state.landmark_user.filter(user=>prop.payment_user_id==user.id)[0]["label"] : ""
      }
    });
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  search(refreshTaskFlag = true) {
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    var searchParmas = this.search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = "50";
    Request.get(this.state.search_url, 
      searchParmas
      , res => {
          this.setState({
            paging: {
              "index": parseInt(searchParmas["pager_index"]),
              "limit": parseInt(searchParmas["pager_limit"])
            },  
            data: this.dataMap(res.Data)
          });
    })
    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }
  /* #1168-2021.7.15 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        this.setState({data_count: res.Data});
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }

  search_field_cols() {
    return (
      <>
        <Col md="3">
          <InputText
            label='見積ID'
            name='ESTIMATE__estimate_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">          
          <InputText
            label='顧客担当者TEL'
            name='CUSTOMER_USER__customer_user_tel'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputText
            label='仕入先TEL'
            name='SUPPLIER__supplier_tel'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col md="3">
          <InputCheckBox
            label='仕入依頼ステータス'
            name='ESTIMATE__payment_request_status'
            labelOn={true}
            validateCallback={this.validateCallback}
            options={cst_payment_request_status_search}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
      </>
    );
  }
  add_field_cols() {
    return (
	<>
        
	</>
    );
  }
  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return (
        <>
          <Col md="3">
            <InputSelect
              label="調査担当者"
              name="REQUEST__onsite_survey_account"
              labelOn={true}
              options={this.state.landmark_user}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              isSearchable={true}
              validateType={'search'}
            />
          </Col>
          <Col md="3">
          <InputSelect
              label='仕入先担当者'
              name='ESTIMATE__payment_user_id'
              labelOn={true}
              options={this.state.landmark_user}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              isSearchable={true}
            />
          </Col>
        </>
      );
  }
  checkbox_field_cols(){
    return (
      <>
      </>
    );
  }

  callbackErrorModal(messageNo){
    this.props.alertModal.current.showErrorModal({messageNo:messageNo})
  }

  dialog_defines() {
    // console.log('state',this.state)
    return (
      <>
        <DialogChangeAmt
          ref={this.dialogchangeamt}
          {...this.props}
          data={this.state.dialogData}
          positive={true}
          toggleErrorModalCallback={this.callbackErrorModal}
          refreshCallback={this.search}
          handleClickNegative={()=>this.setState({dialogData:{}})}
          positive_label="保存"
          negative_label="キャンセル"
        />
        <DialogLostBid
          ref={this.dialogLostBid}
          {...this.props}
          data={this.state.dialogData}
          positive={true}
          toggleErrorModalCallback={this.callbackErrorModal}
          refreshCallback={this.search}
          handleClickNegative={()=>this.setState({dialogData:{}})}
          positive_label="保存"
          negative_label="キャンセル"
        />
        <DialogUpload ref={this.dialogUpload} 
          {...this.props}
          data={this.state.dialogData}
          positive={true}
          positive_label="保存"
          negative_label="キャンセル"
          refreshCallback={this.search}
          />
      </>
    );
  }
}

export class DialogChangeAmt extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '調整額を変更してください',
      estimate: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });
    this.validate = this.validate.bind(this);
    this.calculateNewCost = this.calculateNewCost.bind(this)
    this.validateCallback = this.validateCallback.bind(this);
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.data!=this.props.data || prevState.modal !== this.state.modal){
      this.setState({
        estimate:this.calculateNewCost({
          values: this.props.data,
          errors:{
            // ...(this.props.data.quote_cost_adjustment?{}:{quote_cost_adjustment:[GetMessage(2024)]})
          },
          requiredData:{
            // quote_cost_adjustment:[GetMessage(2024)],
          }
        })
      });
    }
  }

  validate() {
    let message = getErrorCodes(this.state.estimate.errors)

    if(this.state.estimate.values._SUM_all_amt < 0){
      message.push(2444)
    }

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive() {
    this.props.handleClickPositive && this.props.handleClickPositive();
    if(this.validate()) {

      if(this.state.estimate.values._SUM_all_amt < 0){
        this.props.toggleErrorModalCallback(2444);
        return;
      }

      // 調整額 更新API呼び出し
      // url put estimate??? need to check after testable data created
      const url = domain + '/api/estimate/' + this.state.estimate.values.ulid;
      Request.put(url, this.state.estimate.values, res => {
        this.props.refreshCallback();
        this.toggleModal();
      });
    // ## バリデーションエラーモーダルは要確認 ##
    }
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.toggleModal();
  }

  validateCallback(newData, callback=()=>{}){
    const data = this.state.estimate;
    this.setState({
      estimate:{
        ...data,
        ...this.calculateNewCost(newData)
      }
    }, ()=>callback())
  }

  calculateNewCost(newData){
    const {
      quote_cost_total_amt,
      quote_cost_security_deposit_total_amt,
      quote_cost_adjustment,
    } = newData.values
    const _SUM_all_amt = this.returnNumber(quote_cost_total_amt)
     + this.returnNumber(quote_cost_security_deposit_total_amt)
      + this.returnNumber(quote_cost_adjustment)
    return {
      values:{
        ...newData.values,
        _SUM_all_amt,
        survey_cost_commission_type:1
      },
      errors:newData.errors,
      requiredData:newData.requiredData
    }
  }
  
  returnNumber(val){
    return isNaN(Number(val))?0:Number(val)
  }

  bodyContent(){
    const {
      estimate_natural_id,
      latest_pdf_survey_url,
      _SUM_all_amt,
      quote_cost_total_amt
    } = this.state.estimate.values
    return(
      <>
        <Table>
          <tbody>
            <tr>
              <th>見積ID</th>
              {/*## 見積IDのリンク先が決まり次第修正すること ##*/}
              <td>
                <a href={GoogleDrive.getFormatUrl(latest_pdf_survey_url)} target="_blank">
                  {estimate_natural_id}
                </a>
              </td>
            </tr>
            <tr>
              <CustomTd 
                label="仕入値合計" 
                name="ESTIMATE__quote_cost_total_amt"
                copy={false}
                value={Format.comma_delimited(quote_cost_total_amt, "円")}
              />
            </tr>
            <tr>
              <CustomTd label='敷金合計額'
                  name='ESTIMATE__quote_cost_security_deposit_total_amt'
                  copy={false}
                  rootData={this.state.estimate}
                  value={
                    <InputNumber
                      validateCallback={this.validateCallback} 
                      validateType='regist'
                      size={12}
                      unit="円"
                    />
                  }
              />
            </tr>
            <tr>
              <CustomTd label='調整額'
                  name='ESTIMATE__quote_cost_adjustment'
                  copy={false}
                  rootData={this.state.estimate}
                  value={
                    <InputNumber
                      validateCallback={this.validateCallback} 
                      validateType='regist'
                      size={12}
                      unit="円"
                    />
                  }
              />
            </tr>
            <tr>
              <CustomTd 
                label="仕入値合計＋敷金合計額＋調整額" 
                name="___SUM_all_amt"
                copy={false}
                value={Format.comma_delimited(_SUM_all_amt, "円")}
              />
            </tr>
          </tbody>
        </Table>
        <hr />
      </>
    );
  }
}

export class DialogUpload extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '仕入先からの請求書アップロード',
      data: {
        values:{},
        errors:{}
      }
    });
    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.data !== this.props.data || prevState.modal !== this.state.modal){
      this.setState({
        data: {
          values:{
            ...this.props.data,
          },
          errors:{
            ...(this.props.data.latest_pdf_supplier_invoice_url?{}:{latest_pdf_supplier_invoice_url:[GetMessage(2024)]}),
            ...(this.props.data.survey_parking_address_contract?{}:{survey_parking_address_contract:[GetMessage(2024)]}),
          },
          requiredData:{
            latest_pdf_supplier_invoice_url:[GetMessage(2024)],
            survey_parking_address_contract:[GetMessage(2024)],
          }
        }
      })
    }
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      data:{
        ...this.state.data,
        ...newData
      },
    }, ()=>callback())
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive(){
    if(!this.validate()){
      return;
    }
    const params = {
      ...this.state.data.values,
    }
    //TO DO UPLOAD API ENDPOINT
    // latest_pdf_supplier_invoice_url
    // latest_pdf_supplier_invoice_url_base64
    Request.put('/api/order/file_upload/' + this.state.data.values.ulid, params,(res)=>{
      console.log(res)
      if (res.Code==200){
        this.props.refreshCallback();
        this.toggleModal();
      }
    })
  }

  bodyContent() {
    return (
      <>
        <InputFile 
          label="請求書"
          name="ESTIMATE__latest_pdf_supplier_invoice_url"
          copy={false}
          validateCallback={this.validateCallback} 
          showLink={true}
          rootData={this.state.data} 
          filename={`請求書_${moment().format("YYYYMMDDHHmmss")}`}
          />
        <InputText
          labelOn={true}
          label='土地の地番（契約書記載の所在地）'
          name='ESTIMATE__survey_parking_address_contract'
          validateCallback={this.validateCallback} 
          rootData={this.state.data}
          validateType='regist'
        />
      </>
    );
  }
}

export class DialogLostBid extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '失注',
      estimate: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });
    this.validate = this.validate.bind(this);
    this.validateCallback = this.validateCallback.bind(this);
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.data !== this.props.data || prevState.modal !== this.state.modal){
      this.setState({
        data: {
          values:{
            ...this.props.data,
          }
        }
      })
    }
  }

  validate() {
    return true;
  }

  handleClickPositive() {
    this.props.handleClickPositive && this.props.handleClickPositive();
    if(this.validate()) {

      const checked_data  = [
        {
          payment_ulid:this.props.data.payment_ulid,
          estimate_natural_id_ssv:this.props.data.estimate_natural_id,
          updatetimestamp : this.props.data.payment_update_timestamp,
        }
      ]
      const url = '/api/payment/lost_bid';
      // console.log(checked_data,this.props.data)
      Request.put(url, {checked_data}, res => {
        this.props.refreshCallback();
        this.toggleModal();
      });
    }
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.toggleModal();
  }

  validateCallback(newData, callback=()=>{}){
  }
  
  returnNumber(val){
    return isNaN(Number(val))?0:Number(val)
  }

  bodyContent(){
    return(
      <>
        失注にします。よろしいですか？
      </>
    );
  }
}


export default List;
